/** @param {string} html */
export function parseNetsmsHtml(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const stats = {
    available: doc.getElementById('stat_available')?.textContent?.trim() || '0',
    countries: doc.getElementById('stat_countries')?.textContent?.trim() || '0',
    successRate: doc.getElementById('stat_success')?.textContent?.trim() || '99.2%',
    avgResponse: doc.getElementById('stat_resp')?.textContent?.trim() || '1.8秒',
  };

  const countries = [];
  doc.querySelectorAll('#countrySelect option').forEach((opt) => {
    const value = opt.getAttribute('value');
    if (!value) return;
    countries.push({ value, label: opt.textContent.trim() });
  });

  const cards = [];
  doc.querySelectorAll('#cardGrid .card').forEach((el) => {
    const flag = el.querySelector('.flag')?.textContent?.trim() || '';
    const countryDisplay = el.querySelector('.country div:last-child')?.textContent?.trim() || '';
    const phone = el.querySelector('.phone')?.textContent?.trim() || '';
    const priceText = el.querySelector('.price')?.textContent?.trim() || '';
    const used = el.querySelector('.used')?.textContent?.trim() || '';
    const receivedText = el.querySelector('.badge')?.textContent?.trim() || '';
    const receivedMatch = receivedText.match(/(\d+)/);
    const signalEl = el.querySelector('.signal');
    let signal = 'mid';
    if (signalEl?.classList.contains('strong')) signal = 'strong';
    else if (signalEl?.classList.contains('weak')) signal = 'weak';

    const href = el.querySelector('a.btn.primary')?.getAttribute('href') || '';
    const params = new URLSearchParams(href.replace(/&amp;/g, '&').split('?')[1] || '');

    cards.push({
      flag,
      countryDisplay,
      countryEn: params.get('country_en') || countryDisplay,
      countryZh: decodeURIComponent(params.get('country_zh') || countryDisplay),
      phone,
      phoneRaw: params.get('phone') || phone.replace(/\s|-/g, ''),
      price: params.get('price') || priceText.replace(/[^\d.]/g, ''),
      priceText,
      used,
      received: receivedMatch ? parseInt(receivedMatch[1], 10) : 0,
      signal,
      getCodeHref: href.replace(/&amp;/g, '&'),
    });
  });

  return { stats, countries, cards };
}

export function signalLabel(signal) {
  if (signal === 'strong') return '强';
  if (signal === 'weak') return '弱';
  return '中';
}

export function buildGetCodeUrl(agent, card) {
  const params = new URLSearchParams({
    agent: agent || '',
    phone: card.phoneRaw,
    price: String(card.price),
    country_en: card.countryEn,
    country_zh: card.countryZh,
  });
  return `https://nimark.top/netsms/get_code?${params.toString()}`;
}
